import React from 'react';
import styled from 'styled-components';

import Layout from 'antd/es/layout';

import { Row } from 'components/layout';
import theme from 'config/themes';

import Logo from './components/Logo';

const StyledLayout = styled(Layout)`
  height: 100vh;
  background-color: unset;
`;

const Content = styled(Layout.Content)`
  display: block;
  height: 100%;
`;

const Header = styled(Layout.Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${props => props.isBtcView ? (theme.btcColor || theme.primaryColor) : theme.primaryColor};
  box-sizing: content-box;
  position: relative;

  font-size: 2vw;
  line-height: 5vh;
  padding: 0 4vh;
  height: 9vh;
`;

const HeaderRow = styled(Row)`
  margin-left: calc(20.833vw - 4vh - 1vw);
`;

const StyledLogo = styled(Logo)`
  height: 5vh;
  width: 11vw;
  position: absolute;
  left: calc(10.4167vw - 5.5vw);
  top: 50%;
  transform: translateY(-50%);
`;

const MonitorLayout = ({ title, extra, children, className, isBtcView = false }) => {
  const logoInverse = isBtcView ? (theme.btcLogoInverse ?? true) : true;

  return (
    <StyledLayout className={className}>
      <Header isBtcView={isBtcView}>
        <StyledLogo className="logo" inverse={logoInverse} />
        <HeaderRow align="middle">
          {title}
        </HeaderRow>
        <Row className="header-extra">
          {extra}
        </Row>
      </Header>
      <Content>
        {children}
      </Content>
    </StyledLayout>
  );
};

export default MonitorLayout;
